module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('field-dialog', {
    attrs: {
      "bus": _vm.bus
    },
    on: {
      "cancel": _vm.dialogCancelled,
      "submit": _vm.dialogSubmitted
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "fields"
  }, [_c('ul', {
    staticClass: "fields__list"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fields.length === 0),
      expression: "fields.length === 0"
    }],
    staticClass: "fields__list--empty"
  }, [_vm._v("\n                    Wybierz pole po prawej stronie.\n                ")]), _vm._v(" "), _vm._l((_vm.fields), function(field, i) {
    return _c('li', {
      staticClass: "field",
      class: {
        'field--error': _vm.errors[i] && Object.keys(_vm.errors[i]).length > 0
      },
      on: {
        "click": function($event) {
          return _vm.editField(field, _vm.errors[i])
        }
      }
    }, [_c('div', {
      staticClass: "buttons"
    }, [(i !== _vm.fields.length - 1) ? _c('el-button', {
      attrs: {
        "size": "small",
        "title": "Przesuń w dół"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.changeOrder(_vm.fields, i, 1)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-arrow-down"
    })]) : _vm._e(), _vm._v(" "), _c('el-button', {
      style: ({
        opacity: i !== 0 ? 1 : 0
      }),
      attrs: {
        "size": "small",
        "title": "Przesuń do góry"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.changeOrder(_vm.fields, i, -1)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-arrow-up"
    })]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "danger",
        "size": "small"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeField(field, i)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-remove"
    })])], 1), _vm._v(" "), _c('strong', [_vm._v(_vm._s(field.text_pl || field.label_pl || 'Pusta nazwa'))]), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.getLabel(field.resourcetype)))])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "types"
  }, [_c('ul', {
    staticClass: "types__list"
  }, _vm._l((_vm.$store.state.fieldTypes), function(type, key) {
    return _c('li', {
      staticClass: "type",
      on: {
        "click": function($event) {
          return _vm.addField(key)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus-circle"
    }), _vm._v(" " + _vm._s(type.label) + "\n                ")])
  }), 0)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v("\n            Pola formularza\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b9532b5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fields/FieldsInput.vue
// module id = 762
// module chunks = 0